import { Navigate, Route, Routes } from "react-router-dom";

import PayoutRescuePage from "./pages/PayoutRescuePage";

/** Sub-router for `/app/payout-rescue/*`. */
export const PayoutRescueNavigation = () => {
  return (
    <Routes>
      <Route index element={<PayoutRescuePage />} />
      <Route path="*" element={<Navigate to="/app/payout-rescue" replace />} />
    </Routes>
  );
};
